import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles.css";

/**
 * The demo accounts and the product name are stamped into the page by the
 * server, which sends them only for the local identity provider — the
 * pilot's stand-in for a directory. Against real Entra there are none, and
 * enumerating accounts would be a gift to whoever is guessing.
 */
const boot = (window as any).__NEEV__ ?? { accounts: [], product: "Neev" };

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename="/app">
      <App accounts={boot.accounts} product={boot.product} />
    </BrowserRouter>
  </StrictMode>,
);
